import { Suspense } from "react"
import { BrowserRouter } from "react-router-dom"
import { I18nextProvider, useTranslation } from "react-i18next"
import i18n from "@/i18n"
import { AppRoutes } from "@/app/router"
import LangHtmlSync from "@/app/LangHtmlSync"
import ScrollToTop from "@/app/ScrollToTop"
import { QueryProvider } from "@/app/QueryProvider"
import { AuthProvider } from "@/app/auth/AuthProvider"
import { LoadingBlock } from "@/widgets/LoadingBlock"

const PageLoader = () => {
  const { t } = useTranslation()
  return <LoadingBlock variant="page" message={t("common.loading")} />
}

export default function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <LangHtmlSync />
      <QueryProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AuthProvider>
            <ScrollToTop />
            <Suspense fallback={<PageLoader />}>
              <AppRoutes />
            </Suspense>
          </AuthProvider>
        </BrowserRouter>
      </QueryProvider>
    </I18nextProvider>
  )
}
